// Login API function
import { API_PATHS } from "../paths";
import axios from "axios";
import { flashMessage } from "../../utils/flashMessageService";

export async function loginUser(credentials) {
  try {
    const response = await axios.post(
      API_PATHS.login,
      credentials,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      const message = data?.error || "Login failed. Please try again.";
      if (status === 400) {
        console.error("login failed with status 400:", data);
      } else {
        console.error("Error logging in user:", error);
      }
      flashMessage(message, { type: "error" });
    } else {
      console.error("Error logging in user:", error);
      flashMessage("Login failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}

export async function requestPasswordReset(email) {
  try {
    const response = await axios.post(
      API_PATHS.forgotPassword,
      { email },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      const message = data?.error || data?.message || "Unable to process password reset.";
      if (status === 404) {
        flashMessage(message, { type: "error" });
      } else if (status === 400) {
        flashMessage(message, { type: "error" });
      } else {
        flashMessage(message || "Password reset request failed. Please try again.", { type: "error" });
      }
      console.error("Password reset request failed:", error);
    } else {
      console.error("Error requesting password reset:", error);
      flashMessage("Password reset request failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}

export async function resetPassword(payload) {
  try {
    const response = await axios.post(
      API_PATHS.resetPassword,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      const message = data?.error || data?.message || "Unable to reset password.";
      if (status === 400) {
        flashMessage(message, { type: "error" });
      } else if (status === 404) {
        flashMessage(message, { type: "error" });
      } else {
        flashMessage(message || "Password reset failed. Please try again.", { type: "error" });
      }
      console.error("Password reset failed:", error);
    } else {
      console.error("Error resetting password:", error);
      flashMessage("Password reset failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}
